/* eslint-disable no-console */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
// import { CloseIcon } from '../PeerRecognition/styles';
import { /*StyledModal, StyledHeader, StyledBody,*/ Container, LeftSection, /*RightSection,*/ Img, Content, /*Button,*/ TabsContainer, Tab, /*HeaderText*/ } from './styles';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { fetchApi } from '../../utils/methods';
import { connect } from 'react-redux';
import { unFriendUser, sendFriendRequest } from '../../redux/actions';
import { Modal } from 'react-bootstrap';
import { StyledTitle, StyledModal, StyledBody } from '../RecogntionAdmin/corevalues/styles';
import { RecognitionCloseIcon } from '../../utils/icons';
import { BorderBottom } from '../RecogntionAdmin/styles';
import LazyImage from '../common/LazyImage/LazyImage';
import { ImageUrl } from '../../utils/constants';
import SkeletonLoder from '../common/skeletonLoder';

const LikePopUp = ({ showModal, onClose, feedNumber, t,/*unFriendUser, sendFriendRequest*/ }) => {
  const [postLikeDetails, setPostLikeDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [tabs, setTabs]=useState(null);
  const [activeTab, setActiveTab]=useState('all');
  const observer = useRef();

  const lastUserElementRef = useCallback((node) => {
    if (isLoading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new window.IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) {
        setPage((prevPage) => prevPage + 1);
      }
    });
    if (node) observer.current.observe(node);
  }, [isLoading, hasMore]);

  const getPostLikedUsers = async (pageNumber, activeTab) => {
    setIsLoading(true);
    try {
      const res = await fetchApi(`/v1/getPostLikedUsers/${feedNumber}/${activeTab}/${pageNumber}/20`, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message);
      } else {
        const { users, pagination, counts } = res.data;
        setPostLikeDetails((prev) => (pageNumber !== 1 ? [...prev, ...users] : [...users]));
        setHasMore(pagination.current_page < pagination.total_pages);
        setTabs(counts)
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      getPostLikedUsers(page, activeTab);
    }
  }, [showModal, page]);

  // const handleRequest = ( status, invitee_id ) => {
  //   window.console.log(status, invitee_id);
  //   if(status===1 || status===2){
  //     unFriendUser(invitee_id, false);
  //     onClose();
  //   }
  //   else if(status===0 || status===3){
  //     sendFriendRequest(invitee_id, false);
  //     onClose();
  //   }
  // }

  const getColor = ()=>("#F37A65")

  return (
    <StyledModal show={showModal} newWidth="620px" newHeight={"520px"}  newBg="newBg" display="none">
      <Modal.Header closeButton onHide={onClose} style={{ background: "white" }}>
        <StyledTitle>{ "Reactions"}</StyledTitle>
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          {RecognitionCloseIcon()}
        </div>
      </Modal.Header>
      <StyledBody>


        <TabsContainer>
          {tabs && Object.entries(tabs)?.map(([tab,count]) => (
            <>
              {count ? <Tab key={tab} active={activeTab === tab} background={getColor || "#F37A65"} onClick={() =>{setActiveTab(tab);getPostLikedUsers(1,tab);setPostLikeDetails([])}}>
                <div className='tab-content' >{tab === "all" ? <span>All</span> : <LazyImage src={ImageUrl+`/social-feed-reactions/${tab}.png`} width={"24px"} height={"24px"}/>}
                  <span className='count'>{count}</span>
                </div>
                <BorderBottom active={activeTab === tab} background={getColor || "#F37A65"} />
              </Tab> : null}
            </>
          ))}
        </TabsContainer>
        <div style={{height:"400px",overflowY:"auto"}}>
          {isLoading && <div style={{ display: "flex", width: "100%", flexWrap: "wrap",marginTop:"10px" }}>
            {Array.from({ length: 2 }).map((_, index) => (
              <SkeletonLoder key={index} width={"495px"} height={"80px"} style={{margin:"0px 20px 20px 0px"}}/>
            ))}
          </div>}
        
          {postLikeDetails.map((data, index) => (
            <Container key={index} ref={index === postLikeDetails.length - 1 ? lastUserElementRef : null}>
              <LeftSection>
                <Img>   
                  {/* <img src={`https://s3.amazonaws.com/images.trainingamigo.com/${data.profile_image}`} style={{ borderRadius: "50%" }} alt="profile" /> */}
                  <img src={ImageUrl + "/" + data?.profile_image} style={{ borderRadius: "50%" }} alt="profile" />
                  <LazyImage div={"like-type"} src={ImageUrl+`/social-feed-reactions/${data.type}.png`} width={"16px"} height={"16px"}/>
                </Img>
                
                <Content>
                  <div>{t(data.liked_by)}</div>
                  <div>{t(data.department)} {data.location ? `| ${data.location}` : "" }</div>
                </Content>
              </LeftSection>
              {/* <RightSection status={data.friend_status} onClick={() => handleRequest(data.friend_status, data.uid)}>
                {data.friend_status === 1 && <Button status={data.friend_status}>{t("Buddies")}</Button>}
                {(data.friend_status === 0 || !data.friend_status) && <Button status={data.friend_status}>{t("Add Buddy")}</Button>}
                {data.friend_status === 2 && <Button status={data.friend_status}>{t("Pending")}</Button>}
              </RightSection> */}
            </Container>
          ))}
        </div>
        {/* {isLoading && <div>{t("Loading...")}</div>} */}
      </StyledBody>
    </StyledModal>
  );
};

LikePopUp.propTypes =  {
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  getPostLikeDetails: PropTypes.func,
  postLikeDetails: PropTypes.array,
  sendFriendRequest: PropTypes.func,
  unFriendUser: PropTypes.func,
  feedNumber : PropTypes.number,
  t: PropTypes.func
};

const mapStateToProps = (state) => ({
  status : state.profileData.requestSent
})

const mapDispatchToProps = (dispatch) => ({
  unFriendUser: (data, bool) => dispatch(unFriendUser(data, bool)),
  sendFriendRequest: (data, bool) => dispatch(sendFriendRequest(data, bool))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LikePopUp));
